import { AuthRecord } from 'pocketbase'
import { create } from 'zustand'
import { pb } from '@/utils/pb'
import { savePreviousAuth } from '@/utils/temp-login'
import { UsersResponse } from '@/utils/types/pocketbase-types'

export interface AuthState {
  auth: {
    reset: () => void
    setUser: (newToken: string, user: UsersResponse) => void
    loginAsTemporary: (
      newToken: string,
      user: UsersResponse,
      previousToken: string | null,
      previousUser: Record<string, unknown> | null
    ) => void
    restorePreviousAuth: (
      previousToken: string,
      previousUser: Record<string, unknown>
    ) => void
    getCurrentUser: () => UsersResponse | null
  }
}

export const useAuthStore = create<AuthState>()((set) => {
  return {
    auth: {
      reset: () =>
        set((state) => {
          pb.authStore.clear()
          return {
            ...state,
            auth: { ...state.auth, user: null },
          }
        }),
      setUser: (newToken: string, user: UsersResponse) => {
        pb.authStore.save(newToken, user as AuthRecord)
      },
      loginAsTemporary: (
        newToken: string,
        user: UsersResponse,
        previousToken: string | null,
        previousUser: Record<string, unknown> | null
      ) => {
        // Save the previous auth data (passed as parameters)
        if (previousToken && previousUser) {
          savePreviousAuth(previousToken, previousUser, user.id)
        }

        // Switch to temporary user
        pb.authStore.save(newToken, user as AuthRecord)
      },
      restorePreviousAuth: (
        previousToken: string,
        previousUser: Record<string, unknown>
      ) => {
        // Restore the previous auth token with complete user record
        pb.authStore.save(previousToken, previousUser as AuthRecord)
      },
      getCurrentUser: () => {
        return pb.authStore.record as UsersResponse | null
      },
    },
  }
})
